/* eslint-disable max-len */
//import { Stack, Typography, useTheme } from "@mui/material";
//import { useTranslation } from "react-i18next";

import { 
  //Avatar, 
  Box, 
  Grid, 
  //Typography, 
  useMediaQuery, 
  useTheme } from "@mui/material";
import { Download, FilePlus, FileText, Replace, Settings, Trash2, Upload, User } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { RevisionItem } from "types";
import { 
  ExercisesCardContainer, 
  FileActions, 
  FileActionsContainer, 
  FileActionsWrapper, 
  //FileUpload,
  GridHeader,
  IconsContainer, 
  StyledTypography, 
  StyledTypographyRow } from "./ExercisesCardTable.style";
import { ExercisesCardTableProps } from "./ExercisesCardTable.types";
import { formatBytes } from "./FormatBytes";
import { getLastUpdateDate } from "./GetLastUpdateUtil";
import { ButtonDigited } from "../../components/Button/Button.variants";
//import { useGetProfileImageQuery } from "../../queries";
import { useDownloadExercise } from "../../queries/exercises";
//import { useAuthStore } from "../../stores";
import { AddNewFileModal } from "../AddNewFileModal";
import { DeleteConfirmContentModal } from "../DeleteConfirmContentModal/DeleteConfirmContentModal.component";
//import { Icon } from "../Icon";
import { ModalFileHistory } from "../ModalFileHistory";


export function ExercisesCardTable(
  {
    editionId,
    exercises,
    teachers
  }: ExercisesCardTableProps
) {

  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [isOpenModalHistory, setIsOpenModalHistory] = useState(false);
  const [isOpenModalUpload, setIsOpenModalUpload] = useState(false);
  const [currentExerciseId, setCurrentExerciseId] = useState<number | null>(null);
  const [addFileFromReplace, setAddFileFromReplace] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [showConfirmModal, setShowConfirmModal] = useState<any>();
  const [currentExerciseIdToReview, setCurrentExerciseIdToReview] = useState<number | null>(null);

  const { mutate: mutateDownloadFile, data: file } = useDownloadExercise(editionId);

  useEffect(() => {
    if(file?.public_url) {
      var element = document.createElement("a");
      element.setAttribute("href", file?.public_url);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  }, [file]);
  
  useEffect(() => {
    setCurrentExerciseIdToReview(null);
  }, [exercises]);

  //TODO DOWNLOAD LOGIC

  const handleClose = () => {
    setIsOpenModalHistory(false);
    setIsOpenModalUpload(false);
  };

  /*const userData = useAuthStore(state => state.userData);
  const { data: profileImage  } = useGetProfileImageQuery({});
 
  function getUserAvatar(userData: UserData | null) {
    return {
      initials: `${userData?.name?.replaceAll(" ", "")} ${userData?.surname}`,
      src:  profileImage || undefined
    };
  }

 // const userAvatar = getUserAvatar(userData);

  function stringAvatar(name: string) {
    return {
      children: `${name.split(" ")[0][0].toUpperCase()}${name.split(" ")[1][0].toUpperCase()}`
    };
  }*/

  return (
    <Box sx={ { background:theme.customColors.drawerWidgetBg,  border: `2px solid ${theme.customColors.border}`, borderRadius: "1rem" } }>
      { !isMobile && <Box           
        sx={ { 
          borderBottom: `1px solid ${theme.customColors.border}`,
          padding: isMobile ? theme.spacing(2,1) : theme.spacing(2,3) 
        } }>
        <Grid
          sx={ {
            alignItems: "center",
            display: "flex"
          } }
          container 
          columnSpacing={ { md: 5, sm: 2, xs: 1 } } >
          <GridHeader item xs={ 3 }>
            <StyledTypography>
              { t("from_teacher") }
            </StyledTypography> 
          </GridHeader>
          <GridHeader item xs={ 3 }>
            <StyledTypography>
              { t("sent") }
            </StyledTypography>
          </GridHeader>
          <GridHeader item xs={ 3 }>
            <StyledTypography>
              { t("review") }
            </StyledTypography>
          </GridHeader>
          <GridHeader item xs={ 3 }>
            <StyledTypography>
              { t("last_update") }
            </StyledTypography>
          </GridHeader>
        </Grid>
      </Box> }
      { exercises?.map((exerciseRow, index) => {
        const lastUpdateDate = getLastUpdateDate(
          exerciseRow.revisions[0]?.assignment_last_update_date, 
          exerciseRow.exercise_last_update_date,
          exerciseRow.revisions[0]?.correction_last_update_date);
        // const idUserUpdate = exerciseRow.revisions[0]?.updated_by;
        //const updateUserImg = teachers.find(teacher => teacher.id === idUserUpdate) ?  teachers.find(teacher => teacher.id === idUserUpdate)?.image :
        // userAvatar.src;
        // const updateUserInitials = teachers?.find(teacher => teacher.id === idUserUpdate) ?  teachers.find(teacher => teacher.id === idUserUpdate)?.completeName :
        //  userAvatar.initials;


        return (
          <ExercisesCardContainer key={ `exercise_${index}` }>
            <Grid className="cards-grid" container columnSpacing={ { md: 5, sm: 2,  xs: 1 } }>
              <FileActionsContainer item xs={ 12 } sm={ 3 } md={ 3 }className="from-teacher">
                { isMobile && 
                  <StyledTypography>
                    { t("from_teacher") }
                  </StyledTypography> }
                { isMobile && 
                  <StyledTypography>
                    { exerciseRow?.teacher_id.label }
                  </StyledTypography> }
                <FileActionsWrapper>
                  { !isMobile &&
                    <Box sx={ { display:"flex", alignItems: "center" } }>
                      <User size={ 20 }/> 
                      <StyledTypographyRow sx={ { ml: "0.5rem" } }>
                        { exerciseRow?.teacher_id.label }
                      </StyledTypographyRow> 
                    </Box>
                  }
                  <Box sx={ { display:"flex", alignItems: "center" } }>
                    <FileText size={ 20 } />
                    <StyledTypographyRow sx={ { ml: "0.5rem" } } >
                      { exerciseRow?.exercise_id.label }
                    </StyledTypographyRow>
                    <Download  
                      style={ { marginLeft:"1rem",cursor:"pointer" } }
                      size={ 20 }
                      color={ theme.customColors.exploreCardText }
                      onClick={ ()=> mutateDownloadFile({ exerciseId: exerciseRow?.exercise_id.id, mediaId: exerciseRow?.exercise_id.id, type: "EXERCISE" }) }
                    />
                  </Box>
                </FileActionsWrapper>
              </FileActionsContainer>
        
              <FileActionsContainer item xs={ 12 } sm={ 3 } md={ 3 } className="from-learner">
                { isMobile && 
                  <StyledTypography>
                    { t("sent") }
                  </StyledTypography> }
                <FileActionsWrapper sx={ { marginTop: "auto" } }>
                  { !!exerciseRow?.revisions[0]?.assignment_id?.label && currentExerciseIdToReview !== exerciseRow.exercise_id.id  && <FileActions sx={ {
                    marginTop: "auto"
                  } }>
                    <StyledTypographyRow >
                      { exerciseRow?.revisions[0]?.assignment_id?.label }
                    </StyledTypographyRow>
                    <IconsContainer direction="row" gap={ theme.spacing(2) }>
                      <Download  style={ { cursor:"pointer" } }  color={ theme.customColors.exploreCardText } size={ isMobile ? 14 :20 }
                        onClick={ ()=> mutateDownloadFile({ exerciseId: exerciseRow?.exercise_id.id, mediaId: exerciseRow?.revisions[0]?.assignment_id?.id as number, type: "ASSIGNMENT" }) }
                      />
                      { exerciseRow?.revisions[0]?.outcome !== "DA_RIVEDERE" &&
                        <div className={ 
                          `  icon-wrap ${exerciseRow?.revisions[0]?.outcome === "CHIUSO" || 
                        exerciseRow?.revisions[0]?.outcome === "IN_REVISIONE" ? 
                            "disabled" : 
                            ""}` }
                        >
                          <Replace
                            style={ { cursor:"pointer" } }
                            size={ isMobile ? 14 :20 }
                            color={ exerciseRow?.revisions[0]?.outcome === "CHIUSO" 
                            || exerciseRow?.revisions[0]?.outcome === "IN_REVISIONE" ? 
                              theme.customColors.systemDisabled : 
                              theme.customColors.exploreCardText  }
                            onClick={ () => {
                              setAddFileFromReplace(true);
                              setIsOpenModalUpload(true);
                              setCurrentExerciseId(exerciseRow?.exercise_id.id);
                            } }
                          />
                        </div> }
                      { exerciseRow?.revisions[0]?.outcome === "DA_RIVEDERE" && 
                        <FilePlus
                          style={ { cursor:"pointer" } } 
                          size={ isMobile ? 14 :20 }
                          color={ theme.customColors.exploreCardText }
                          onClick={ () => {
                            setCurrentExerciseIdToReview(exerciseRow.exercise_id.id);
                          } }
                        /> }
                      <div className={ `icon-wrap ${exerciseRow?.revisions[0]?.outcome === "CHIUSO" || exerciseRow?.revisions[0]?.outcome === "IN_REVISIONE" ? "disabled" : ""}` }>
                        <Trash2
                          style={ { cursor:"pointer" } } 
                          size={ isMobile ? 14 :20 }
                          color={ exerciseRow?.revisions[0]?.outcome === "CHIUSO" || exerciseRow?.revisions[0]?.outcome === "IN_REVISIONE" ? theme.customColors.systemDisabled : theme.customColors.exploreCardText }
                          onClick={ () => setShowConfirmModal(exerciseRow) }
                        />
                      </div>
                    </IconsContainer>
                  </FileActions> 
                  }
                  { (!exerciseRow?.revisions[0]?.assignment_id || currentExerciseIdToReview === exerciseRow.exercise_id.id ) && <Box sx={ { display:"flex",alignItems: "center" } }gap={ "8px" }               
                  >
                    <ButtonDigited  onClick={ () => {
                      setAddFileFromReplace(false);
                      setIsOpenModalUpload(true);
                      setCurrentExerciseId(exerciseRow?.exercise_id.id);
                    } } typology="secondary" buttonSize="md"  selfPosition="flex-end" sx={ { marginRight:"1rem" } }>
                      <Box sx={ { display:"flex",gap:1 } }>
                        <Upload size={ 20 }/> 
                        <StyledTypography>{ t("upload_file") }</StyledTypography> 
                      </Box> 
                    </ButtonDigited>
                  </Box> }
                  { !!exerciseRow?.revisions[0]?.assignment_id?.label && currentExerciseIdToReview !== exerciseRow.exercise_id.id  &&   
                    <StyledTypographyRow >
                      { formatBytes(Number(exerciseRow?.revisions[0]?.assignment_size)) }
                    </StyledTypographyRow>  }
                  { /* Done end*/ }
                </FileActionsWrapper>
              </FileActionsContainer>

              <FileActionsContainer item xs={ 12 } sm={ 3 } md={ 3 } className="review">
                { isMobile && <StyledTypography>
                  { t("review") }
                </StyledTypography> }
                { exerciseRow?.revisions[0]?.correction_id?.label ? <FileActionsWrapper sx={ { marginTop: "auto" } }>
                  <Box sx={ { display:"flex", alignItems: "center" } }>
                    <StyledTypographyRow >
                      { exerciseRow?.revisions[0]?.correction_id?.label }
                    </StyledTypographyRow>
                    <Download  style={ { cursor:"pointer" } }  color={ theme.customColors.exploreCardText } size={ isMobile ? 14 :20 }
                      onClick={ ()=> mutateDownloadFile({ exerciseId: exerciseRow?.exercise_id.id, mediaId: exerciseRow?.revisions[0]?.correction_id?.id as number, type: "CORRECTION" }) }
                    />
                  </Box>
                  { exerciseRow?.revisions[0]?.correction_size && 
                    <StyledTypographyRow>
                      { formatBytes(Number(exerciseRow?.revisions[0]?.correction_size)) }
                    </StyledTypographyRow>
                  }
                </FileActionsWrapper> : "-" }
              </FileActionsContainer>
        
              <FileActionsContainer item xs={ 12 } sm={ 3 } md={ 3 } className="last-update">
                { isMobile && 
                  <StyledTypography>
                    { t("last_update") }
                  </StyledTypography> }
                <StyledTypographyRow >
                  { lastUpdateDate }
                </StyledTypographyRow>
                { !!exerciseRow.revisions.length && !!exerciseRow.revisions.some(rev => !!rev.assignment_id) && <Settings
                  style={ { cursor:"pointer"  } } 
                  size={ isMobile ? 14 :20 }
                  color={ theme.customColors.exploreCardText } 
                  onClick={ () => {
                    setIsOpenModalHistory(true);
                    setCurrentExerciseId(exerciseRow?.exercise_id.id);
                  } }/> }
              </FileActionsContainer>
            </Grid>
          </ExercisesCardContainer>
        ); 
      }) }
      {
        isOpenModalHistory ? (
          <ModalFileHistory
            teachers={ teachers }
            editionId={ editionId }
            revisions={ exercises?.find(exercise => exercise.exercise_id.id === currentExerciseId)?.revisions as RevisionItem[] }
            teacherName={ exercises?.find(exercise => exercise.exercise_id.id === currentExerciseId)?.teacher_id.label as string }
            teacherImg={ teachers.find(teacher => teacher.id === exercises?.find(exercise => exercise.exercise_id.id === currentExerciseId)?.teacher_id.id)?.image }
            exerciseName={ exercises?.find(exercise => exercise.exercise_id.id === currentExerciseId)?.exercise_id.label as string }
            exerciseId={ exercises?.find(exercise => exercise.exercise_id.id === currentExerciseId)?.exercise_id.id as number }
            anchorEl={ document.body }
            anchorOrigin={ {
              horizontal: "center",
              vertical: "center"
            } }
            transformOrigin={ {
              horizontal: "center",
              vertical: "top"
            } }
            closeDrawer={ handleClose }
            onClose={  handleClose }
            open={ isOpenModalHistory }
          />
        ) : null
      }
      {
        isOpenModalUpload ? (
          <AddNewFileModal
            isReplace={ addFileFromReplace }
            revisionId={ exercises?.find(exercise => exercise.exercise_id.id === currentExerciseId)?.revisions[0]?.revision_id as number }
            editionId={ editionId }
            exerciseId={ exercises?.find(exercise => exercise.exercise_id.id === currentExerciseId)?.exercise_id.id as number }
            anchorEl={ document.body }
            anchorOrigin={ {
              horizontal: "center",
              vertical: "center"
            } }
            transformOrigin={ {
              horizontal: "center",
              vertical: "top"
            } }
            closeDrawer={ handleClose }
            onClose={  handleClose }
            open={ isOpenModalUpload }
          />
        ) : null
      }
      <DeleteConfirmContentModal
        closeDrawer={ ()=> setShowConfirmModal(null) }
        deleteId={ editionId }
        open={ !!showConfirmModal }
        data={ showConfirmModal }
      />
    </Box>
  );
}
